export { registerWalletActions } from "@cogo/runtime-v2"
export type { WalletConfig } from "@cogo/runtime-v2"
